import { render, staticRenderFns } from "./ViqRelatedTopics.vue?vue&type=template&id=9517db46&scoped=true"
import script from "./ViqRelatedTopics.vue?vue&type=script&lang=js"
export * from "./ViqRelatedTopics.vue?vue&type=script&lang=js"
import style0 from "./ViqRelatedTopics.vue?vue&type=style&index=0&id=9517db46&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9517db46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9517db46')) {
      api.createRecord('9517db46', component.options)
    } else {
      api.reload('9517db46', component.options)
    }
    module.hot.accept("./ViqRelatedTopics.vue?vue&type=template&id=9517db46&scoped=true", function () {
      api.rerender('9517db46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqRelatedTopics.vue"
export default component.exports